module.exports = __webpack_public_path__ + "static/kv-small-d9a8a6af82b600016b26cb834a254eff.png";